import { getCookieChild, getElement, ifSelectorExist } from "./utils";

export const contactUsSwapAddress = () => {
  let selectedCity = getCookieChild('selectedCity');

  let targetEl = getElement('.contact-us__swap-adrress');
  let mapWrapper = getElement('.contact-info-form-map-block--wrapper iframe')

  if ((selectedCity == 'Columbus' ) && ifSelectorExist(targetEl)) {
    targetEl.innerHTML = `4171 Arlingate Plaza, <br> Columbus, OH 43228`;

    if (ifSelectorExist(mapWrapper)) {
      mapWrapper.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12227.548488342534!2d-83.1160846!3d39.9886278!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88389187df099f81%3A0x1ed50c2af17dc627!2sBassett%20Services%3A%20Heating%2C%20Cooling%2C%20Plumbing%2C%20%26%20Electrical!5e0!3m2!1sen!2shr!4v1729629266543!5m2!1sen!2shr')
    }
  }
}